import React from 'react';

import numericalLinearAlgebraCover from '../../assets/literature/numerical-linear-algebra.svg';
import numericalAnalysisCover from '../../assets/literature/numerical-analysis.svg';
import convexOptimizationCover from '../../assets/literature/convex-optimization.svg';
import probabilisticNumericsCover from '../../assets/literature/probabilistic-numerics.svg';
import einfuehrungInDieNumerischeMathematikCover from '../../assets/literature/eunfuehrung_in_die_numerische_mathematik_riwawi.png';
import numericalOptimizationCover from '../../assets/literature/numerical_optimization_nowright.png';

const books = [
  {
    id: 'einfuehrung-in-die-numerische-mathematik',
    title: 'Einführung in die Numerische Mathematik',
    subtitle: 'Begriffe, Konzepte und zahlreiche Anwendungsbeispiele',
    author: 'Thomas Richter, Henry von Wahl, Thomas Wick',
    year: 2024,
    href: 'https://link.springer.com/book/10.1007/978-3-662-69582-1',
    cover: einfuehrungInDieNumerischeMathematikCover,
    alt: 'Stylised cover of Numerical Linear Algebra showing matrix relations',
  },
  {
    id: 'numerical-optimization',
    title: 'Numerical Optimization',
    subtitle: '',
    author: 'Jorge Nocedal & Stephen J. Wright',
    year: 2011,
    href: 'https://link.springer.com/book/10.1007/978-0-387-40065-5',
    cover: numericalOptimizationCover,
    alt: 'Gradient cover for Numerical Analysis with derivative formula illustration',
  },
];

export default function LiteraturePage() {
  return (
    <section className="relative mx-auto w-full max-w-6xl px-6 pb-24 pt-28 text-white lg:px-16">
      <div className="pointer-events-none absolute inset-x-0 top-14 -z-10 h-72 rounded-full bg-gradient-to-r from-[#8b5cf6]/30 via-[#22d3ee]/25 to-[#ec4899]/30 blur-3xl" />
      <header className="mb-12 space-y-4 text-center lg:text-left">
        <p className="text-sm uppercase tracking-[0.35em] text-white/60">Learning library</p>
        <h1 className="text-4xl font-semibold leading-tight md:text-5xl">Literature</h1>
        <p className="mx-auto max-w-4xl text-lg text-white/70 lg:mx-0">
          Curated textbooks and monographs for students of numerical methods and applied mathematics.
        </p>
      </header>

      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {books.map((book) => (
          <article
            key={book.id}
            className="group flex flex-col rounded-3xl border border-white/10 bg-white/90 p-6 text-slate-900 shadow-[0_35px_65px_-45px_rgba(76,29,149,0.65)] transition hover:-translate-y-1 hover:shadow-[0_30px_75px_-40px_rgba(76,29,149,0.8)] focus-within:-translate-y-1 focus-within:shadow-[0_30px_75px_-40px_rgba(76,29,149,0.85)]"
          >
            <img
              src={book.cover}
              alt={book.alt}
              className="h-56 w-full rounded-2xl object-cover shadow-inner mb-4"
            />

            {/* View book button directly below the image */}
            <a
              href={book.href}
              target="_blank"
              rel="noreferrer"
              aria-label={`Open ${book.title} (${book.year}) in a new tab`}
              className="mb-4 inline-flex w-full items-center justify-center rounded-full bg-slate-900 px-5 py-2 text-sm font-semibold text-white shadow-lg transition hover:bg-slate-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#8b5cf6] focus-visible:ring-offset-white"
            >
              View book
            </a>

            {/* Book details below the button */}
            <div className="flex flex-col text-center text-slate-900 space-y-1">
              <h2 className="text-lg font-semibold leading-snug">{book.title}</h2>
              {book.subtitle && (
                <p className="text-sm text-slate-600">{book.subtitle}</p>
              )}
              {book.author && (
                <p className="text-sm text-slate-700">{book.author}</p>
              )}
              <p className="text-sm text-slate-500">{book.year}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
